import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { Row, Col } from 'reactstrap';
// import { LinkContainer } from 'react-router-bootstrap';
// Local Deps
import './InventoryManagementDefinitionForm.scss';
import msgs from '../../../config/messages';
import formConfig from './formConfig';
import NFButton from '../../primitives/NFButton';
// import { inventoryManagementRoute } from '../../../config/navigation/routes';

function InventoryManagementDefinitionForm({
  onSubmit,
  initialValues = {},
  handleInitalValueReset,
  closeEditModal,
}) {
  return (
    <div className="nf-tooling-def-form">
      <Form
        onSubmit={onSubmit}
        initialValues={initialValues}
        render={({ handleSubmit, pristine, invalid, submitting, reset }) => (
          <form onSubmit={handleSubmit}>
            {/* <h3>Edit Inventory Management</h3> */}
            <div>
              {formConfig.map((fieldConfig) => (
                <Field key={fieldConfig.name} {...fieldConfig} />
              ))}
              <Row>
                <Col className="text-center">
                  <NFButton
                    className="nf-button--gray-border"
                    disabled={submitting}
                    onClick={() => {
                      closeEditModal();
                    }}
                  >
                    {msgs.Form.cancelButton}
                  </NFButton>
                  <NFButton
                    className="nf-button--gray-border"
                    onClick={() => {
                      handleInitalValueReset();
                      reset(initialValues);
                    }}
                    disabled={submitting}
                  >
                    Reset
                  </NFButton>
                  <NFButton id='button'
                    className="nf-button--form nf-button--orange"
                    type="submit"
                    disabled={pristine || invalid || submitting}
                  >
                    {msgs.Form.submitButton}
                  </NFButton>
                </Col>
              </Row>
            </div>
          </form>
        )}
      />
    </div>
  );
}

InventoryManagementDefinitionForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  handleInitalValueReset: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
  closeEditModal: PropTypes.func.isRequired,
};

InventoryManagementDefinitionForm.defaultProps = {
  initialValues: {},
};

export default InventoryManagementDefinitionForm;



// WEBPACK FOOTER //
// ./src/components/forms/InventoryManagementDefinitionForm/InventoryManagementDefinitionForm.jsx